import { Grid, Group, Layout, Page } from "@/comn/components";
import { useTranslation } from "react-i18next";
import { comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useTheme, useToast } from "@/comn/hooks";
import {
    APIS,
    SF_MENU_MGMT,
    SF_MENU_SCRN_SRCH,
    SG_MENU_SCRN_LIST,
    URLS,
} from "@/tz/go/egaz/osci/ptl/ptl/menuscrn/services/OsciMenuScrnService";
import * as menuService from "@/tz/go/egaz/osci/ptl/ptl/menu/services/OsciMenuService";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { OSCI0104009Q } from "@/tz/go/egaz/osci/ptl/ptl/menuscrn/OSCI0104009Q";

/*
 * Create Menu and Screen
 * !== 메뉴 연결 등록 ==!
 */
export const OSCI0104008S = () => {
    const {} = usePage({
        auth: ["auth_osci0003"],
    });
    const { t } = useTranslation();
    const toast = useToast();
    const modal = useModal();
    const navigate = useNavigate();
    const { theme } = useTheme();
    const param = useParams();
    const location = useLocation();
    // console.log(1111);

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "OSC0088" },
            { area: "comnCd", comnCd: "OSC0095" },
        ],
    });

    const grid = {
        menuScrnList: useGrid({ defaultSchema: SG_MENU_SCRN_LIST }),
    };

    const form = {
        menuSrch: useForm({ defaultSchema: SF_MENU_SCRN_SRCH }),
        scrnSrch: useForm({ defaultSchema: SF_MENU_SCRN_SRCH }),
        menuMgmt: useForm({ defaultSchema: SF_MENU_MGMT }),
    };

    const fetch = {
        getMenuDtl: useFetch({
            api: () => menuService.APIS.getMenuInfo(param.menuId),
            onSuccess: (data: any) => {
                const { menuInfo } = data;
                const { menuLangList, ...info } = menuInfo.content;
                form.menuMgmt.setValues(info);
                fetch.getMenuScrnList.fetch();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        getMenuScrnList: useFetch({
            api: () => APIS.getMenuScrnList(param.menuId, location.state.ptlTpCd ?? "O"),
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00043" }), // Failed to select. !== 조회가 실패하였습니다. ==!
        }),
        saveMenuScrnList: useFetch({
            api: () => APIS.saveMenuScrnList(grid.menuScrnList.getData({ excludes: ["origin"] })),
            onSuccess: () => {
                modal.openModal({ content: "msg.osc.00073" }); // Successfully saved. !== 정상적으로 저장되었습니다. ==!
                fetch.getMenuScrnList.fetch();
            },
            onError: () => toast.showToast({ type: "error", content: "msg.osc.00045" }), // Failed to save. !== 저장이 실패하였습니다. ==!
        }),
    };

    const handler = {
        onSaveBtnClick: () => {
            const list = grid.menuScrnList.getData();
            const trgtList = grid.menuScrnList.getData({ excludes: ["deleted"] });
            if (comnUtils.isEmptyArray(list)) {
                modal.openModal({ content: "msg.osc.00199" }); // The screen to connect the menu is not registered. !== 메뉴를 연결할 화면이 등록되지않았습니다. ==!
                return;
            }

            const count = trgtList.length;
            /*
            if (count > 1) {
                modal.openModal({ content: "msg.osc.00217" }); // Only one screen can be set for the menu connection status value 'Y' !== 메뉴 연결 여부 값 'Y'는 단 한 개 화면만 설정 가능합니다. ==!
                return;
            }
            */

            const gridError = grid.menuScrnList.validate();
            if (gridError && !comnUtils.isEmpty(gridError.errors)) {
                modal.openModal({ content: t("msg.osc.00192", { 0: t("T_MENU_SCRN_LIST") }) }); // {{0}}의 필수입력 항목을 확인하시기 바랍니다.
                return;
            }

            const scrnList = grid.menuScrnList.getViewData();
            let cnt = 0;

            if (scrnList.length > 0) {
                scrnList.map((item) => {
                    if (item.menuCnctYn === "Y") {
                        cnt++;
                    }
                });
            }

            console.log(cnt);

            if (cnt != 1) {
                modal.openModal({ content: "msg.osc.00245" });
                return false;
            }

            modal.openModal({
                content: "msg.osc.00090", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                onConfirm: () => fetch.saveMenuScrnList.fetch(),
            });
        },
        onListBtnClick: () => navigate(`${URLS.osci0104007q}`),
        onGridAddBtnClick: () => {
            modal.openModal({
                draggable: true,
                size: "md",
                content: (
                    <OSCI0104009Q
                        {...form.menuMgmt.getValues()}
                        callback={handler.onModalCallback}
                        menuScrnList={grid.menuScrnList.getData({ excludes: ["deleted"] })}
                    />
                ),
            });
        },
        onGridDelBtnClick: () => {
            if (!grid.menuScrnList.isChecked()) {
                modal.openModal({ content: "msg.osc.00193" }); // 삭제대상을 선택하세요.
                return;
            }
            modal.openModal({
                content: "msg.osc.00062",
                onConfirm: () => {
                    grid.menuScrnList.deleteRow("checkbox");
                },
            });
        },
        onModalCallback: (data: any) => {
            if (!comnUtils.isEmptyArray(data)) {
                data.forEach((item: any) => grid.menuScrnList.addRow({ ...item, menuId: param.menuId }));
            }
            modal.closeModal();
        },
    };

    useEffect(() => {
        form.menuMgmt.setEditable(false);
        fetch.getMenuDtl.fetch();
    }, [theme.lang]);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.bsopClsfCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.ptlTpCd} />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.menuMgmt.schema.menuNm} editType="label" viewType="" />
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Title title={"T_MENU_SCRN_LIST"} />
                    <Layout>
                        <Layout.Right>
                            <Layout.Button role={"gridAdd"} onClick={handler.onGridAddBtnClick} />
                            <Layout.Button role={"gridDelete"} onClick={handler.onGridDelBtnClick} />
                        </Layout.Right>
                    </Layout>
                    <Grid {...grid.menuScrnList.grid} data={fetch.getMenuScrnList.data?.menuScrnList ?? {}} />
                </Group.Body>
            </Group>
            <Layout>
                <Layout.Left>
                    <Layout.Button role={"list"} onClick={handler.onListBtnClick} />
                </Layout.Left>
                <Layout.Right>
                    <Layout.Button role={"save"} onClick={handler.onSaveBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
